import React, { useContext, useEffect, useState } from 'react';
import { Flex, Text } from '@chakra-ui/layout';
import { Heading, Spinner } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/icon';
import { MdOutlineRoute, MdArrowBack, MdOutlineLayers, MdChevronRight, MdMoreVert, MdMoreHoriz } from 'react-icons/md';
import InlineFormWrapper from '@/components/inlineFormWrapper';
import ExperienceGroupInProductNameForm from './experienceGroupInProductNameForm';
import ExperiencesInProductListMenu from './experiencesInProductListMenu';
import { ProductContext } from '../../lib/productContext';
import { ProductPageContext } from '../lib/productPageContext';
import { useNavigate } from 'react-router-dom';
import useTranslation from '../../../lib/i18n/useTranslation';
export default function ExperiencesInProductListHeader(props) {
  const { t } = useTranslation();
  const {
    product,
    rights,
  } = useContext(ProductContext);
  const {
    experienceList,
    experienceGroupList,
    sharedExperienceList,
    group,
    parentGroup,
    refreshSharedExperienceList
  } = useContext(ProductPageContext);
  const {refreshList} = props;
  const [goingBack, setGoingBack] = useState(false);
  const navigate = useNavigate();
  const goBack = async () => {
    try {
      setGoingBack(true);
      await refreshList();
      setGoingBack(false);
      if(group?.group.product_experience_group_id) {
        navigate(`/products/${product.id}?group-id=${group.group.product_experience_group_id}`);
      } else {
        navigate(`/products/${product.id}`);
      }
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <Flex
      alignItems='center'
      py={2}
      px={3}
      backgroundColor="white"
      justifyContent={"space-between"}
      h={"54px"}
    >
      <Flex alignItems={"center"}>
        <Flex mr={3} alignItems='center' >
          {goingBack && (
            <Flex mr={3}>
              <Spinner />
            </Flex>
          )}
          {(!goingBack && group) && (
            <Icon
              as={MdArrowBack}
              boxSize="18px"
              mr={3}
              cursor={"pointer"}
              onClick={goBack}
            />
          )}
          <Flex mr={2} alignItems='center'
          cursor={"pointer"}
          onClick={() => {
            navigate(`/products/${product.id}`);
          }}
          >
            <Icon
              as={MdOutlineRoute}
              boxSize="18"
              mr={2}
            />
            <Heading variant="secondary" >{t('product.experiences')}</Heading>
            {group && (
              <Icon
              as={MdChevronRight}
              boxSize="14px"
              ml={2}
              color="text.medium.grey"
            />
            )}
          </Flex>
          {group && 
            <Icon
            as={MdOutlineLayers}
            color="text.medium.purple"
            boxSize="18"
            mr={2}
            />
          }
          {parentGroup && (
            <>
            {parentGroup.group_id && (
              <>
              <Flex
              cursor={"pointer"}
                onClick={() => {
                  navigate('/products/' + product.id + '?group-id=' + parentGroup.group_id)
                 }}
              >
                <Icon
                  as={MdMoreHoriz}
                  boxSize="18px"
                  mr={2}
                  color="text.medium.purple"
                  mt="10px"
                />
              </Flex>
              <Icon
                as={MdChevronRight}
                boxSize="14px"
                mr={2}
                color="text.light.purple"
              />
              </>
            )}
            <Text
              color="text.medium.purple"
              fontWeight={"500"}
              fontSize={"14px"}
               mr={2}
               maxWidth={"150px"}
               textOverflow={"ellipsis"}
               whiteSpace={"nowrap"}
               cursor={"pointer"}
               onClick={() => {
                navigate('/products/' + product.id + '?group-id=' + parentGroup.id)
               }}
            >{parentGroup.group.name}</Text>
            <Icon
              as={MdChevronRight}
              boxSize="14px"
              mr={2}
              color="text.light.purple"
            />
            </>
          )}
          <InlineFormWrapper
            width={"100%"}
            canEdit={rights?.can_update}
            value={
            <Text
            fontSize={"18px"}
            color="text.medium.purple">{group?.group?.name}</Text>}
          >
            {(close) => (
              <Flex pr={3}>
                <ExperienceGroupInProductNameForm
                  groupId={group.id}
                  group={group?.group}
                  onSubmitted={close}
                  onCancel={close}
                />
              </Flex>
            )}
          </InlineFormWrapper>
        </Flex>
        {rights?.can_update &&
          <ExperiencesInProductListMenu
            hasExperiences={!!(experienceList?.length || experienceGroupList?.length || sharedExperienceList?.length)}
            group={group}
            onNew={async () => {
              if (refreshList) await refreshList();
              if (refreshSharedExperienceList && typeof refreshSharedExperienceList === 'function') {
                await refreshSharedExperienceList();
              }
            }}
          />
        }
      </Flex>
    </Flex>
  );
}